module.exports = __webpack_public_path__ + "static/media/house10.992c1dff.png";